import axiosClient from './axiosClient';
import { EventSourcePolyfill } from 'event-source-polyfill';

export default {
  // Recupera tutte le notifiche dell’utente
  lista: async () => {
    const res = await axiosClient.get('/notifiche');
    return res.data;
  },

  // Segna una notifica come letta
  markAsRead: async (notificaId) => {
    const res = await axiosClient.put(`/notifiche/${notificaId}/lettura`);
    return res.data;
  },

  // Segna tutte le notifiche come lette
  segnaTutteLette: async () => {
    const res = await axiosClient.put('/notifiche/lettura');
    return res.data;
  },

  // Conta notifiche non lette
  unreadCount: async () => {
    const res = await axiosClient.get('/notifiche/unreadcount');
    return res.data;
  },

  // SSE / WebSocket con userId
  subscribe: (userId, onMessage) => {
    if (!userId) throw new Error("subscribe: userId non definito");
    console.log("Sottoscrizione notifiche per userId:", userId);
    const token = localStorage.getItem('token');

    // Funzione interna per gestire connessione e reconnect
    const startSSE = () => {
      const es = new EventSourcePolyfill(
        `${process.env.REACT_APP_API_URL}/stream/notifiche?userId=${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      es.onmessage = (e) => {
        try {
          const data = JSON.parse(e.data);
          onMessage(data);
        } catch (err) {
          console.error("Errore parsing notifica SSE:", err);
        }
      };

      es.onerror = () => {
        console.log("SSE errore/reconnect...");
        es.close();
        setTimeout(startSSE, 5000); // richiama la funzione interna per reconnect
      };

      return es;
    };

    const esInstance = startSSE();

    // restituisce funzione per chiudere l'SSE
    return () => esInstance.close();
  }
};
